"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _reactI18next = require("react-i18next");
var _coreLanguagePacks = require("@vfuk/core-language-packs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const resources = {
  en: {
    translation: _coreLanguagePacks.english
  }
};
_i18next.default.use(_reactI18next.initReactI18next).init({
  resources,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});
var _default = _i18next.default;
exports.default = _default;